import { useEffect, useState } from 'react'
import { useParams } from "react-router-dom";
import { Page, Text, View, Document, StyleSheet, PDFViewer, Font, Image, PDFDownloadLink } from '@react-pdf/renderer';
import {Table, TR, TH, TD} from '@ag-media/react-pdf-table';
import axios from 'axios'
import DownloadIcon from '@mui/icons-material/Download';
import Button from '@mui/material/Button';

Font.register({
  family: 'yekan',
  src: '/fonts/IRANYekanRegular(FaNum).ttf'
})
Font.register({
  family: 'yekanB',
  src: '/fonts/IRANYekanBold(FaNum).ttf'
})
Font.register({
  family: 'yekanL',
  src: '/fonts/IRANYekanLight(FaNum).ttf'
})
Font.register({
  family: 'titr',
  src: '/fonts/BTitrBd.ttf'
})
// Create styles
const styles = StyleSheet.create({
  page: {
    direction: 'rtl',
    backgroundColor: '#ffffff',
    fontFamily: 'yekan',
    padding: 20,
    alignItems: 'center',
    justifyContent:'space-between'
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 5,
    width: '100%'
  },
   headerText: {
    fontFamily: 'yekanB',
    fontSize: 14
  },
  text: {
    fontFamily: 'yekan',
    fontSize: 10,
  },
  textB: {
    fontFamily: 'yekanB',
    fontSize: 10
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1
  },
  table: {
    width:'100%',
    borderColor: "1px solid #f3f4f6",
    margin: '10px 0'
  },
   tableHeader: {
   backgroundColor: "#e5e5e5",
   fontFamily: 'yekanB',
   fontSize: 11

  },
  tr: {
   fontFamily: 'yekan',
   fontSize: 10,
   alignItems: 'flex-start'
  },
  td:{
    paddingHorizontal: '6px',
    paddingVertical: '1px',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
  }
});

// Create Document Component
const MyDocument = ({invoiceNo}) => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState(null)
  const [totalAmount, setTotalAmount] = useState(0)
  const [discount, setDiscount] = useState(0)
  const [productBrand, setProductBrand] = useState({})
  const [agent_info, setAgent_info] = useState('')
  const [costs, setCosts] = useState([])
  const [invoice, setInvoice] = useState({})
  const getBrand = async(params) => {
    const response = await axios.post('https://api.fntpf.ir/admin/getProductBrand', params)
    if (response.data.status) setProductBrand(response.data.brand)
    else setProductBrand({brand: '-'})
    console.log('Ashkb', response.data)
  }

  const getData = () => {
    axios.post(`https://api.fntpf.ir/admin/getinvoice`, {id: invoiceNo}).then(response => {
      setData(response.data.invoice)
      axios.post(`https://api.fntpf.ir/admin/getinvoice_agentName`, {phone: response.data.invoice.agent_id}).then(response2 => {
        setAgent_info(response2.data.agent)
        // console.log('TTES', response2.data)
      })
    })
  }

  const calculate = (items) => {
    let value = 0
    items.map((item) => {
      value = value + (Number(item.service_cost) * Number(item.qty))
      setTotalAmount(value)
    })
  }

  const getInvoiceDetails =  async params => {
    const response = await axios.post('https://api.fntpf.ir/invoice/invoice_details', params)
    if (response.data.status) {
      setCosts(response.data.cost)
      setInvoice(response.data.factor)
      calculate(response.data.cost)
      getBrand({product: response.data.factor.product_model})
    } else {
      console.log('خطای دیتا بیس')
      return false
    }
  }
    useEffect(() => {
    getData()
    getInvoiceDetails({request: invoiceNo})

    console.log('ashki')
    // setTimeout(() => window.print(), 3000)
  }, [])
  // setTimeout(() => calculate(), 3000)
  // setTimeout(() => getBrand({product: invoice.product_model}), 1000)

  return (
    <Document title={`ServiceInvoice-${invoiceNo}`}>
      <Page size="A4" style={styles.page} >
        <View style={{width: '100%', alignItems:'center'}}>
          <View style={styles.header}>
            <Image source={require('./images/logo.png')} style={{width: '500px', position: 'absolute', top: window.innerHeight*0.44, opacity: 0.1}}/>
            <View>
              <Text style={styles.textB}>شماره فاکتور: {invoiceNo} </Text>
              <Text style={{...styles.text, fontSize: 8}}>تاریخ ثبت: {data && data.register_date ? data.register_date.split('T')[0] : '-'} {data && data.register_date ? data.register_date.split('T')[1] : '-'} </Text>
              <Text style={{...styles.text, fontSize: 8}}>تاریخ تحویل: {data && data.completed_date ? data.completed_date.split('T')[0] : '-'} {data && data.completed_date ? data.completed_date.split('T')[1] : '-'}</Text>
              <Text style={{...styles.textB, fontSize: 8}}>{invoice.sherkati ? 'کار غیر شرکتی' : 'کار شرکتی'}</Text>
            </View>
            <View style={{alignItems:'center'}}>
              <Text style={styles.headerText}>واحد خدمات پس از فروش</Text>
              <Text style={styles.text}>برگه سرویس و گواهی انجام کار</Text>
              <Text style={{...styles.textB, fontSize: 8}}>فناوران نوین پارسیان تصویر فدک</Text>
            </View>
            <View style={{width: 100}}>
                {(productBrand && (productBrand.brand === 'آلدو' || productBrand.brand === 'سوزوکی')) ? <Image source={require(`./images/${productBrand.brand === 'آلدو' ? 'aldo' : 'suzuki'}.png`)} style={{maxWidth: '200px'}} /> : <Image source={require(`./images/logo.png`)} style={{maxWidth: '200px'}}/>}
            </View>
          </View>
          <View style={{borderWidth:1, borderColor: '#000', width: '100%', marginBottom: '5px'}} />
          {/*//customer*/}
          <View style={{borderWidth:1, width: '100%', alignItems: 'center', backgroundColor: '#e5e5e5', paddingVertical: 2}}>
            <Text style={styles.textB}>اطلاعات مشتری</Text>
          </View>
          <View style={{width: '100%', alignItems: 'flex-start', justifyContent:'space-around', flexDirection:'row'}}>
            <View  style={{flex:2, borderWidth:1, alignItems: 'flex-end', height: '100%' , paddingHorizontal: '3px'}}>
              <Text style={styles.text}>آدرس: {data ? data.merchant_city : '-'}، {data ? data.merchant_address : '-'}</Text>
            </View>
            <View  style={{flex:1, borderWidth:1, alignItems: 'flex-end', height:'100%', paddingHorizontal: '3px'}}>
              <Text style={styles.text}>تلفن: {data ? data.merchant_phone : '-'}</Text>
            </View>
            <View  style={{flex:1, borderWidth:1, alignItems: 'flex-end', height:'100%', paddingHorizontal: '3px'}}>
              <Text style={styles.text}>نام مشتری: {data ? data.merchant_name : '-'}</Text>
            </View>
          </View>
          {/*////Device*/}
          <View style={{marginTop: '5px', borderWidth:1, width: '100%', alignItems: 'center', backgroundColor: '#e5e5e5', paddingVertical: 2}}>
            <Text style={styles.textB}>اطلاعات دستگاه</Text>
          </View>
          <View style={{borderWidth:1, width: '100%', flexDirection:'row', justifyContent:'space-between', alignItems: 'flex-start'}}>
            <View  style={{flex:1, alignItems: 'flex-end', maxWidth: '120px',justifyContent:'space-between', marginTop: '5px'}}>
              <View  style={{alignItems: 'center', flexDirection: 'row'}}>
                <Text style={styles.textB}>گارانتی </Text>
                {invoice && invoice.warranty ? <Image source={require('./images/ok.png')} style={{width: '18px' , height: '18px'}} /> : <Image source={require('./images/x.png')} style={{width: '18px', height: '18px'}} />}
              </View>
              <View  style={{alignItems: 'center', marginTop:'2px', flexDirection: 'row'}}>
                <Text style={styles.textB}> پذیرش درب مغازه </Text>
                {data && data.maqaze ? <Image source={require('./images/ok.png')} style={{width: '18px', height: '18px'}} /> : <Image source={require('./images/x.png')} style={{width: '18px', height: '18px'}} />}
              </View>
            </View>
            <View  style={{flex:1, alignItems: 'flex-end',justifyContent:'space-between'}}>
              <View  style={{ alignItems: 'flex-start', flexDirection: 'row'}}>
                <Text style={styles.text}> {data ? data.service_type : '-'}</Text>
                <Text style={styles.textB}>:نوع درخواست </Text>
              </View>
              <View  style={{ alignItems: 'flex-start', marginTop:'2px', flexDirection: 'row'}}>
                <Text style={styles.text}> {invoice ? invoice.product_category : '-'} {invoice ? invoice.product_model : '-'} {productBrand ? productBrand.brand : ''} </Text>
                <Text style={styles.textB}>:مدل دستگاه </Text>
              </View>
              <View  style={{alignItems: 'flex-start', marginTop:'2px', flexDirection: 'row'}}>
                <Text style={styles.textB}>:مشکل دستگاه </Text>
              </View>
              <View  style={{alignItems: 'flex-end', marginTop:'2px', flexDirection: 'row'}}>
                <Text style={{...styles.text, direction: 'ltr'}}>{data ? data.problem : '-'}</Text>
              </View>
            </View>
          </View>

          <Table style={styles.table}>
            <TH style={{...styles.tableHeader, alignItems:'center', width: '100%'}}>
              <TD style={{justifyContent:'center' , alignItems: 'center', width: '100%'}}>جزئیات کالا و خدمات</TD>
            </TH>
            <TH style={styles.tableHeader}>
                <TD style={{...styles.td, flex: 3}}>مجموع(ریال)</TD>
                <TD style={{...styles.td, flex: 1, maxWidth: '35px'}}>تعداد</TD>
                <TD style={{...styles.td, flex: 3}}>قیمت واحد(ریال)</TD>
                <TD style={{...styles.td, flex: 5}}>شرح</TD>
                <TD style={{...styles.td, flex: 1, maxWidth: '35px'}}>ردیف</TD>
            </TH>
            {
              costs ? costs.map((item, index) => (
                <TR style={styles.tr}>
                  <TD style={{...styles.td, flex: 3, height: '100%'}}>{(item.qty ? Number(item.qty) * Number(item.service_cost) : Number(item.service_cost)).toLocaleString()}</TD>
                  <TD style={{...styles.td, flex: 1, maxWidth: '35px', height: '100%'}}>{item.qty ? item.qty : 1}</TD>
                  <TD style={{...styles.td, flex: 3, height: '100%'}}>{Number(item.service_cost).toLocaleString()}</TD>
                  <TD style={{...styles.td, flex: 5, height: '100%'}}>{item.service_name}</TD>
                  <TD style={{...styles.td, flex: 1, height: '100%', maxWidth: '35px'}}>{index + 1}</TD>
              </TR>
              )) : <TR style={styles.tr}>
                <TD style={{...styles.td, flex: 10,fontFamily: 'yekanB'}}>موردی برای نمایش وجود ندارد</TD>
            </TR>
            }
           
            <TR style={styles.tr}>
                <TD style={{...styles.td, flex: 3,fontFamily: 'yekanB'}}>{totalAmount.toLocaleString()}</TD>
                <TD style={{...styles.td, flex: 10,fontFamily: 'yekanB'}}>مبلغ کل</TD>
            </TR>
            <TR style={styles.tr}>
                <TD style={{...styles.td, flex: 3,fontFamily: 'yekanB'}}>{invoice && invoice.warranty ? totalAmount.toLocaleString() : '0'}</TD>
                <TD style={{...styles.td, flex: 10,fontFamily: 'yekanB'}}>جمع مبلغ به حساب شرکت</TD>
            </TR>
            <TR style={styles.tr}>
                <TD style={{...styles.td, flex: 3,fontFamily: 'yekanB'}}>{invoice && invoice.warranty ? '0' : totalAmount.toLocaleString()}</TD>
                <TD style={{...styles.td, flex: 10,fontFamily: 'yekanB'}}>جمع مبلغ به حساب مشتری</TD>
            </TR>
        </Table>
        {/*///agent*/}
      
          <View style={{borderWidth:1, width: '100%', alignItems: 'center', backgroundColor: '#e5e5e5', paddingVertical: 2}}>
            <Text style={styles.textB}>اطلاعات تکمیلی</Text>
          </View>
          <View style={{marginTop:'20px', width: '100%', alignItems: 'flex-start', justifyContent:'space-between', flexDirection:'row'}}>
            {/*agent avatar*/}
            <View style={{marginHorizontal:'5px', flex:1, justifyContent: 'center', alignItems:'center', borderColor:'#056f96', borderRadius: 10, borderWidth: 1 , padding: '10px'}}>
              <Text style={styles.text}>مشخصات تکنسین</Text>
              <View style={{width: 50, borderRadius: 25, marginVertical: '5px'}}>
                <Image style={{borderRadius: 25}} source={{uri: agent_info.img_uri ? `https://api.fntpf.ir/assets/uploaded/images/${agent_info.img_uri}` : `https://api.fntpf.ir/assets/uploaded/images/undefined.jpg`}}/>
              </View>
              <Text style={styles.text}>{agent_info.firstname} {agent_info.lastname}</Text>
              <Text style={styles.text}>{agent_info.phone}</Text>
            </View>
            <View style={{marginHorizontal:'5px',flex: 4, alignItems:'flex-end', borderColor:'#056f96', borderRadius: 10, borderWidth: 1 , padding: '10px'}}>
              { invoice &&  invoice.sherkati &&
              <View style={{flexDirection:'row', justifyContent:'flex-end'}}>
                <Text style={styles.text}> {invoice &&  invoice.sherkati && invoice.sherkati_desc  ? invoice.sherkati_desc : '-'} </Text>
                <Text style={styles.textB}>:توضیحات کار غیر شرکتی</Text>
              </View>
              }
              { invoice &&  invoice.sherkati && <View style={{borderWidth:0.3, borderColor: '#000', width: '95%', marginVertical: '5px'}} />}
              <View style={{flexDirection:'row', justifyContent:'flex-end'}}>
                <Text style={styles.text}>{invoice ? invoice.description : '-'}</Text>
                <Text style={styles.textB}>:توضیحات فاکتور</Text>
              </View>
            </View>
          </View>
        </View>
        <View style={{width: '100%', alignItems:'center'}}>
          <View style={{width: '100%', alignItems:'flex-end'}}>
            <Table style={styles.table}>
              <Text style={{...styles.textB, alignSelf:'flex-end', marginBottom: '4px', fontSize: 9}}>.خدمات سالم و بدون نقص تحویل اینجانب {invoice.receptor_name} گردید  *</Text>
              <TH style={styles.tableHeader}>
                  <TD style={{...styles.td, flex: 1, fontSize: 9}}>نام و امضاء مشتری</TD>
                  <TD style={{...styles.td, flex: 1, fontSize: 9}}>نام و امضاء شرکت</TD>
                  <TD style={{...styles.td, flex: 3, fontSize: 9}}>قابل توجه مشتریان گرامی</TD>
              </TH>
              <TR style={styles.tr}>
                  <TD style={{...styles.td, flex: 1, height: '103%'}}>
                    <Image style={{maxHeight: '50px'}} source={invoice && invoice.receptor_signature ? `data:image/png;base64,${String.fromCharCode.apply(null, invoice.receptor_signature.data)}` : null}/>
                    <Text style={{...styles.text, fontSize: 7}}>{invoice.receptor_name}</Text>
                  </TD>
                  <TD style={{...styles.td, flex: 1, height: '103%', flexDirection: 'column', justifyContent:'center'}}>
                    <Image source={require('./images/stamp.png')} style={{width: '100px'}}/>
                    <Text style={{...styles.text, fontSize: 7}}>فناوران نوین پارسیان تصویر فدک</Text>
                  </TD>
                  <TD style={{...styles.td, flex: 3}}>
                    <View style={{alignItems: 'flex-end', padding: 1}}>
                      <Text style={{...styles.text, fontSize: 8, direction:'rtl'}}> مشکلات ناشی از مخدوش شدن هولوگرام، بارکد و خرابی ناشی از نوسانات برق و آبخوردگی یا تعمیر توسط تعمیرکاران غیرمجاز شامل گارانتی نمی شود.</Text>
                      <Text style={{...styles.text, fontSize: 8, direction: 'rtl'}}>      برای ارائه خدمات بهتر و کیفیت محصول با انتقادات و پیشنهادات خود ما را یاری فرمایید.</Text>
                      <Text style={{...styles.text, fontSize: 8}}>پیامک: 90002350        تلفن: 021-78446</Text>
                    </View>
                  </TD>
              </TR>
          </Table>
          </View>
        </View>
      </Page>
    </Document>
  );
}
const AdminPrint = () => {
    const routeParams = useParams();
  
  return (
  <div>
    <div style={{height: window.innerHeight}}>

      <PDFDownloadLink document={<MyDocument invoiceNo={(Number(routeParams.invoiceNo)/1375 - 5119)/1371} fileName='ServiceInvoice'/>}>
      <Button style={{width: '100%'}} variant="contained" endIcon={<DownloadIcon />}> ذخیره فاکتور </Button>
      </PDFDownloadLink>
      <PDFViewer width='100%' height='100%'>
        <MyDocument invoiceNo={(Number(routeParams.invoiceNo)/1375 - 5119)/1371} />
      </PDFViewer>
    </div>
  </div>
)};

export default AdminPrint;